import { SVGProps } from "react";

// A real volleyball — three panel sections seaming out from the center (the
// Tabler ball-volleyball paths, MIT-licensed), not a basketball's cross.
export const Volleyball = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    <path d="M12 12a8 8 0 0 0 8 4" />
    <path d="M7.5 13.5a12 12 0 0 0 8.5 6.5" />
    <path d="M12 12a8 8 0 0 0 -7.464 4.928" />
    <path d="M12.951 7.353a12 12 0 0 0 -9.88 4.111" />
    <path d="M12 12a8 8 0 0 0 -.536 -8.928" />
    <path d="M15.549 15.147a12 12 0 0 0 1.38 -10.611" />
  </svg>
);

export const Calendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="3.2" y="5" width="17.6" height="15.5" rx="2" />
    <line x1="3.2" y1="9.3" x2="20.8" y2="9.3" />
    <line x1="8" y1="3" x2="8" y2="6.4" />
    <line x1="16" y1="3" x2="16" y2="6.4" />
  </svg>
);

export const Bell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M6 9a6 6 0 0 1 12 0c0 4 1 5 1.6 6h-15.2c.6-1 1.6-2 1.6-6" />
    <path d="M10 18.5a2 2 0 0 0 4 0" />
  </svg>
);

export const Unlink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  {...props}
  >
    <path d="M9.5 14.5l-1.8 1.8a3.6 3.6 0 0 1-5.1-5.1l1.8-1.8" />
    <path d="M14.5 9.5l1.8-1.8a3.6 3.6 0 0 1 5.1 5.1l-1.8 1.8" />
  </svg>
);

export const DiscordMark = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 127 96" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M107.7,8.07A105,105,0,0,0,81.47,0a72,72,0,0,0-3.36,6.83A97.7,97.7,0,0,0,49,6.83,72,72,0,0,0,45.64,0,105.9,105.9,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21A105.7,105.7,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.4,68.4,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.6,75.6,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.7,68.7,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1A105.3,105.3,0,0,0,126.6,80.22C129.24,52.84,122.09,29.11,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,46,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53s5-12.74,11.44-12.74S96.23,46,96.12,53,91.08,65.69,84.69,65.69Z" />
  </svg>
);
